<template>
  <div>
    <v-alert v-if="error" type="error" class="mb-0">
      {{ error }}
    </v-alert>

    <div class="d-flex justify-space-between align-center flex-wrap mb-4 gap-4">
      <v-card elevation="0" :loading="loading" class="flex-grow-1">
        <div class="pa-1 d-flex">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Busque por nome"
            single-line
            outlined
            hide-details
            clearable
            dense
            class="flex-grow-1"
          />
        </div>
      </v-card>
    </div>

    <v-row>
      <v-col
        v-for="company in filteredCompanies"
        :key="company.id"
        cols="12"
        md="12"
      >
        <v-card
          outlined
          class="pa-4"
          rounded="lg"
          :to="{
            name: 'ultimate.companies.management',
            params: { id: company.id },
          }"
        >
          <div class="d-flex align-center gap-2">
            <base-avatar
              :seed="company.id"
              :size="35"
              avatarStyle="glass"
              color="secondary lighten-2"
            />
            <h6 class="mb-0">
              {{ company.name }}
            </h6>
          </div>
          <div>
            <p class="mb-0 mt-2 font-weight-medium">
              {{ company.Platform.length }} Plataform{{
                company.Platform.length > 1 ? "as" : "a"
              }}
            </p>

            <div class="d-flex flex-wrap gap-2">
              <v-tooltip
                v-for="platform in company.Platform"
                :key="platform.id"
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-card v-bind="attrs" v-on="on" outlined class="pa-1">
                    <v-img
                      :src="platform.logos.dark"
                      width="50"
                      height="50"
                      contain
                    />
                  </v-card>
                </template>
                <span>{{ platform.name }}</span>
              </v-tooltip>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
  
  <script>
import COMPANY from "@/services/ultimate/company";
import PlatformCard from "@/components/ultimate/platform/PlatformCard.vue";
import { mapGetters } from "vuex";

export default {
  name: "Companies",
  metaInfo: {
    title: "Empresas",
  },
  components: {
    PlatformCard,
  },
  data: () => ({
    loading: false,
    error: null,
    search: "",
    companies: [],
  }),
  methods: {
    async getCompanies() {
      try {
        this.loading = true;
        this.error = null;
        const data = await COMPANY.getAll();
        this.companies = data.companies;
      } catch (error) {
        console.log(error);
        this.error = error.message || "Erro ao buscar empresas";
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapGetters("company", ["selectedCompany"]),
    filteredCompanies() {
      if (!this.search) return this.companies;

      return this.companies.filter((company) =>
        company.name.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },
  watch: {
    "selectedCompany.id"() {
      this.companies = [];
      this.getCompanies();
    },
  },
  mounted() {
    this.getCompanies();
  },
};
</script>
  
  <style></style>
  